<script>
    import { getContext } from 'svelte'
    
    export let card
    export let items
    export let id
    export let effect = "move"
    export let resolve
    export let allowTransition
    export let finishTransition
    
    let dragging = null
    let active   = false
    let allowed  = false

    let ctx = getContext('ctx')

    function onLaneEnter(evt) {
        evt.preventDefault()
        active  = true
        ctx.to  = id
        allowed = allowTransition(ctx)
    }

    function onLaneLeave(evt) {
        evt.preventDefault()
        active  = false
        allowed = false
    }

    function onLaneOver(evt) {
        evt.preventDefault()
    }

    function onLaneDrop(evt) {
        evt.preventDefault()
        active   = false
        dragging = null
        const copy = Object.assign({ to: id }, ctx)
        ctx.reset()
        finishTransition(copy) //.then(console.log).catch(console.error)
    }

    function onDragStart(item) {
        return (evt) => {
            dragging = resolve(item)
            // console.log('start', id, item.inquiry.protocol)
            ctx.reset()
            ctx.from = id
            ctx.item = item
            evt.dataTransfer.dropEffect = effect
        }
    }

    function onDragEnd(item) {
        return (evt) => {
            // console.log('end', id, item.inquiry.protocol)
            dragging = null
            ctx.reset()
        }
    }
</script>
<style>
    .lane {
        min-height: 500px;
        border-radius: 1em;
    }

    .lane.active.allowed {
        background-color: rgba(0,0,0,0.1)
    }

    .card {
        margin: .5em 0;
        transition: opacity 1s ease;
    }

    .dragging {
        opacity: 30%;
    }
</style>
<div class="lane" 
     class:active
     class:allowed
     on:dragenter = { onLaneEnter }
     on:dragleave = { onLaneLeave }
     on:drop      = { onLaneDrop  }
     on:dragover  = { onLaneOver  }
     >
    {#each items as item (resolve(item))}
        <div class="card"
             class:dragging = { dragging === resolve(item) }
             on:dragstart   = { onDragStart(item) } 
             on:dragend     = { onDragEnd(item)   }
             draggable      = true>
            <svelte:component this={card} {item} dragged = { dragging === resolve(item) } />
        </div>
    {/each}

</div>
